import './chart.style.less'

import { debounce, isEmpty } from 'lodash'

import { Bar } from 'react-chartjs-2'
import MainWrapper from './MainWrapper'
import { useState, useLayoutEffect } from 'react'

interface props {
  title: string
  sign?: string
  showLegend?: boolean
  stacked?: boolean
  data: any
  id: string
  target?: any
  periods?: string[]
  onPeriodChange?: (period: string) => any
}

function MHorizontalBar(props: props) {
  const {
    data,
    showLegend = true,
    title,
    sign = '',
    stacked = false,
    id,
    target = false,
    periods = [],
    onPeriodChange = () => {},
  } = props

  const [plugins, setPlugins] = useState<any>()

  useLayoutEffect(() => {
    const plugins = [
      {
        id: 'liveboard',
        beforeInit: function (chart) {
          // Get reference to the original fit function
          const originalFit = chart.legend.fit
          // Override the fit function
          chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)()
            this.height += 10
          }
        },
      },
    ]

    setPlugins(plugins)
  }, [])

  const [options, setOption] = useState<any>({
    indexAxis: 'y' as const,
    plugins: {
      datalabels: {
        align: 'end' as const,
        anchor: 'end' as const,
        font: { size: 14 },
        formatter: (val) => {
          return val + sign
        },
      },
      legend: {
        position: 'top' as const,
        display: showLegend,
        padding: {
          top: -10,
        },
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
    },
    layout: {
      padding: {
        top: 10,
        left: 20,
        right: 20,
      },
    },
    scales: {
      y: {
        stacked: stacked,
      },
      x: {
        stacked: stacked,
        ticks: {
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  })

  const onTarget = (value) => {
    if (!isEmpty(value)) {
      setOption({
        ...options,
        plugins: {
          ...options.plugins,
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                xMin: value,
                xMax: value,
                borderColor: '#ADADAD',
                borderWidth: 3,
                borderDash: [4],
              },
            },
          },
        },
      })
    } else {
      const tmpValue = {
        ...options,
        plugins: {
          ...options.plugins,
        },
      }
      delete tmpValue.plugins.annotation
      setOption(tmpValue)
    }
  }

  return (
    <MainWrapper
      id={id}
      title={title}
      isTarget={target}
      onTarget={debounce(onTarget, 500)}
      onPeriodChange={onPeriodChange}
      periods={periods}
    >
      <Bar redraw data={data} options={options} plugins={plugins} />
    </MainWrapper>
  )
}
export default MHorizontalBar
